import React from 'react';
import { compose } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './AvailMainSideSummaryRooms.js';
import { RichText } from '@synergycms_core/components/generic';
import connect from 'react-redux/es/connect/connect';
import Price from '@synergycms_core/components/generic/Price';
import { withContent } from '@synergycms_core/components/providers/translateProvider';


const AvailMainSideSummaryRooms = class AvailMainSideSummaryRooms extends React.Component {
  static displayName = 'AvailMainSideSummaryRooms';

  render() {
    const { config, theme, content } = this.props,
      {
        totalPriceRooms,
        groupedRooms,
        stepCode,
        reservationTMS
      } = config;
    const { classes } = theme.styles;
    
    return (
      <div className={classes.contentModule}>
        <div className={classes.contentModuleRow}>
          <div className={[classes.contentModuleCell, classes.large, classes.contentModuleCellTitle].join(' ')}>
            <RichText text={content.t('_%Habitaciones%_')} innerStyle={['uppercase']}/>
          </div>
          <div className={[classes.contentModuleCell, classes.contentModuleCellPrice].join(' ')}>
            <Price
              innerStyle={['summaryPriceSize15']}
              amount={totalPriceRooms}
              forceHotelCurrency={stepCode === 'confirmation'}
            />
          </div>
        </div>
        {reservationTMS && (
          <div key={0} className={classes.contentModuleRow}>
            <div className={[classes.contentModuleCell, classes.large].join(' ')}>
              <div className={classes.roomContainer}>
                <RichText text={'1 x '} innerStyle={['roboto15Gray', classes.contentModuleCellRoom]} />
                <RichText text={reservationTMS && reservationTMS.get('room_description', '')} innerStyle={['roboto15Gray', classes.contentModuleCellRoom]} />
              </div>
              <div className={classes.roomContainer}>
                <RichText text={reservationTMS && reservationTMS.get('mealplan_description', '')} innerStyle={['roboto13Gray',classes.contentModuleCellRate]}/>
              </div>
            </div>
            <div className={[classes.contentModuleCell, classes.short, classes.contentModuleCellPrice].join(' ')}>
              <Price
                innerStyle={['roboto13Gray', classes.priceNumbers]}
                amount={totalPriceRooms}
                forceHotelCurrency={stepCode === 'confirmation'}
              />
            </div>
          </div>
        )}
        {groupedRooms && groupedRooms.map((room, key) =>
          <div key={key} className={classes.contentModuleRow}>
            <div className={[classes.contentModuleCell, classes.large].join(' ')}>
              <div className={classes.roomContainer}>
                <RichText text={room.quantity + ' x '} innerStyle={['roboto15Gray', classes.contentModuleCellRoom]} />
                <RichText text={room.roomName} innerStyle={['roboto15Gray', classes.contentModuleCellRoom]} />
              </div>
              <div className={classes.roomContainer}>
                <RichText text={room.boardName} innerStyle={['roboto13Gray',classes.contentModuleCellRate]}/>
              </div>
              {room.rateInfo && room.rateInfo.get('name', '').length > 0 && (
                <div className={classes.roomContainer}>
                  <RichText text={room.rateInfo.get('name')} innerStyle={['roboto13Gray', classes.contentModuleCellRateName]}/>
                </div>
              )}
              {room.rateInfo && room.rateInfo.get('description', '').length > 0 && (
                <div className={classes.roomContainer}>
                  <RichText text={room.rateInfo.get('description')} innerStyle={['roboto13Gray', classes.contentModuleCellRateDescription]}/>
                </div>
              )}
            </div>
            <div className={[classes.contentModuleCell, classes.short, classes.contentModuleCellPrice].join(' ')}>
              <Price
                innerStyle={['roboto13Gray', classes.priceNumbers]}
                amount={room.amount}
                forceHotelCurrency={stepCode === 'confirmation'}
              />
              <br />
              <RichText
                translate={true}
                ucFirst={true}
                text={room.showAvailPriceAsText}
                innerStyle={['roboto13Gray']}
              />
            </div>
          </div>
        )}
      </div>
    )

  }
};


const mapStateToProps = (store, ownProps) => {
  
  return {
    stepCode: store.getIn(['customer', 'step', 'current_step', 'code']),
  };
};


export default compose(
  validateAsyncComponent(mapStateToProps, []),
  connect( mapStateToProps, ),
  PropertyManager([
    'totalPriceRooms',
    'groupedRooms',
    'stepCode',
    'reservationTMS',
  ]),
  withThemeJSS({ styleFile, link: true }),
  withContent('i18n')
)(AvailMainSideSummaryRooms);
